export default __webpack_public_path__ + "static/media/merge.cd86f927.svg";